import InputPreset from '../preset';

const OBSERVED_ATTRIBUTES = [
  'disabled',
  'name',
  'placeholder',
  'readonly',
  'required',
  'value',
];

export default class ZipInput extends InputPreset {
  static observedAttributes = OBSERVED_ATTRIBUTES;
  static reflectedAttributes = OBSERVED_ATTRIBUTES;
  static attributeTypes = {
    disabled: 'boolean',
    readonly: 'boolean',
    required: 'boolean',
  };

  constructor() {
    /*
     * TODO: Presently, to get the numpad to show up on a mobile device:
     * - IOS: `pattern="[0-9]*"` (`pattern="[0-9]{5}"` does NOT work).
     * - Android: `type="number"`, `type="tel"`
     * https://stackoverflow.com/a/27005531
     *
     * We want to avoid using `number` or `tel` since they're semantically
     * incorrect and may trigger native web experiences that are undesirable for
     * zip code entry (e.g. "spinner" in Chrome). We could consider
     * `type="number"` for mobile devices only, but it's incompatible with
     * `minlength` and `maxlength`. Product decided that `maxlength` working is
     * more important than showing the numpad on Android.
     *
     * `inputmode="numeric"`, once fully supported, will solve this problem
     * entirely.
     *
     * Great post on the subject:
     * https://www.filamentgroup.com/lab/type-number.html
     */
    super(
      {
        inputmode: 'numeric',
        minlength: '5',
        maxlength: '5',
        pattern: '[0-9]*',
      },
      [zipValidator]
    );
  }
}

customElements.define('upd-zip-input', ZipInput);

function zipValidator(element) {
  const { value } = element;
  // The `required` validator handles the falsy case.
  // TODO: If `minlength` had better support, we could look at
  // `element.validity` flags (`patternMismatch, `tooShort` and `tooLong`)
  // instead of matching against a pattern.
  const isValid = !value || value.match(/[0-9]{5}/);
  element.setCustomValidity(isValid ? '' : `Please enter a valid zip code.`);
  return isValid;
}
